import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  const yesList = ['Eres emprendedor, coach o consultor', 'Vendes servicios o productos digitales', 'Quieres consistencia sin quemarte', 'Probaste la IA pero no obtuviste resultados reales', 'Tienes un negocio pero no tienes tiempo para crear contenido', 'Quieres parecer un experto en tu nicho'];
  const noList = ['Buscas resultados sin implementar nada', 'No tienes ningún negocio o proyecto', 'Quieres un servicio donde alguien lo haga todo por ti', 'Crees que la IA reemplaza completamente el criterio humano'];
  return <section className="py-28 px-6 bg-darker text-center" data-id="element-109">
      <div className="max-w-[800px] mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-111">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-112">
            ¿Es para mí?
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-12 text-white" data-id="element-113">
            Este sistema es para ti si...
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-cardBg border border-[rgba(0,210,106,0.3)] rounded-2xl p-8 text-left" data-id="element-115">
            <h3 className="text-[18px] font-extrabold mb-5 flex items-center gap-2.5 text-green" data-id="element-116">
              ✅ SÍ es para ti
            </h3>
            <ul className="flex flex-col gap-3 list-none" data-id="element-117">
              {yesList.map((item, i) => <li key={i} className="text-[14px] text-[#CCCCCC] flex items-start gap-2.5 leading-[1.5]" data-id="element-118">
                  <span className="shrink-0 text-[16px]" data-id="element-119">✓</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-cardBg border border-[rgba(255,59,59,0.3)] rounded-2xl p-8 text-left" data-id="element-120">
            <h3 className="text-[18px] font-extrabold mb-5 flex items-center gap-2.5 text-[#FF3B3B]" data-id="element-121">
              ❌ NO es para ti
            </h3>
            <ul className="flex flex-col gap-3 list-none" data-id="element-122">
              {noList.map((item, i) => <li key={i} className="text-[14px] text-[#CCCCCC] flex items-start gap-2.5 leading-[1.5]" data-id="element-123">
                  <span className="shrink-0 text-[16px]" data-id="element-124">✗</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}